export default {"src":"/_next/static/media/success-icon.7cdb04f0.svg","height":48,"width":48};